import { ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService, DebugLoggerService, HelperService} from 'src/app/admin-core/services';
import {Constants} from "src/app/admin-core/constants";
import {QuoteOrderSampleService} from 'src/app/admin-core/apiservices';
import {QuoteService} from 'src/app/admin-core/apiservices/quote.service';
import {FormAutofocusDirective} from '../../directives/form-autofocus.directive';

@Component({
  hostDirectives: [FormAutofocusDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-update-site-contact-detail-modal',
  templateUrl: './update-site-contact-detail-modal.component.html',
  styleUrls: ['./update-site-contact-detail-modal.component.css', '../../../app.component.css']
})
export class UpdateSiteContactDetailModalComponent implements OnInit {
  @Input() modelOrder!: any;
  @Input() isScheduleDeliveryUpdate!: any;
  @Input() isDefult: boolean = true;
  @Input() isOfflineOrder: boolean = false;
  isLoading = false;
  siteContactForm!: UntypedFormGroup;
  submitted = false;
  options = {
    componentRestrictions: {country: 'AU'},
    strictBounds: true,
    fields: ['ALL'],
    types: ['address'],
  };
  isLoadingTruck = false;
  truckDetail: any;
  is_quote = false;
  today = new Date();
  constants = Constants;
  isQuoteAccepted = false;
  accountHolder = false;

  constructor(
    public activeModel: NgbActiveModal,
    private fb: UntypedFormBuilder,
    public helperServices: HelperService,
    private orderService: QuoteOrderSampleService,
    private alertService: AlertService,
    private quoteService: QuoteService,
    private debugLogger: DebugLoggerService
  ) {
  }

  ngOnInit(): void {
    if (this.modelOrder.type == Constants.ORDER_TYPE_QUOTE_SHORT) {
      this.is_quote = true;
    }
    if (this.modelOrder?.acceptedActivity && this.modelOrder?.acceptedActivity?.id) {
      this.isQuoteAccepted = true;
    }

    this.siteContactForm = this.fb.group({
      name: [this.modelOrder.quote_site_contact?.[0]?.name || '', [Validators.required]],
      number: [this.modelOrder.quote_site_contact?.[0]?.number || '', [Validators.required, Validators.minLength(10), this.mobileValidator.bind(this)]],
      email: [this.modelOrder.quote_site_contact?.[0]?.email || '', [Validators.email]],
    });

    this.patchValue()
  }

  private mobileValidator(control: UntypedFormControl): { [s: string]: boolean } {
    if (this.siteContactForm && control.value !== '' && control.value !== null) {
      let $mobileNumber = control.value;
      if ($mobileNumber.substring(0, 2) == '04') {
        return {};
      }
    }
    return {mobileNotValid: true};
  }

  get da() {
    return this.siteContactForm.controls;
  }

  accountHolderCheck(e: any) {
    e.preventDefault();

    if (e.target.checked === true) {
      this.siteContactForm?.patchValue({
        name: this.modelOrder.quoteOwner ? (this.modelOrder.quoteOwner.first_name ?? '') + " " + (this.modelOrder.quoteOwner.last_name ?? '') : '',
        number: this.modelOrder.quoteOwner?.mobile || '',
        email: this.modelOrder.quoteOwner?.email || '',
      });
    } else {
      this.siteContactForm?.patchValue({
        name: '',
        number: '',
        email: '',
      });
    }
  }

  patchValue() {
    if (this.modelOrder.quote_site_contact?.[0]?.name === this.modelOrder.quoteOwner?.first_name + " " + this.modelOrder.quoteOwner?.last_name && this.modelOrder.quote_site_contact?.[0]?.number === this.modelOrder.quoteOwner?.mobile && this.modelOrder.quoteOwner?.email === this.modelOrder.quote_site_contact?.[0]?.email) {
      this.accountHolder = true;
    }
  }

  cancel() {
    this.activeModel.close(false)
  }

  onSubmit() {
    this.submitted = true;
    if (this.siteContactForm.invalid) return;
    this.isLoading = true;
    let siteContactId;
    
    if (!this.modelOrder.quote_site_contact?.[0]?.id || this.modelOrder.quote_site_contact?.[0]?.id === this.modelOrder.defaultQuoteSiteContactId) {
      this.siteContactForm.value.quote_id = this.modelOrder.id;
      if (!this.isScheduleDeliveryUpdate) {
        if (this.isDefult) {
          this.siteContactForm.value.is_default = true;
        }
      } else {
        this.siteContactForm.value.quote_schedule_delivery_id = this.modelOrder.quote_schedule_delivery_id;
        siteContactId = this.modelOrder.quote_site_contact?.[0]?.id;
      }
      this.modelOrder.quote_site_contact = [{}];
    }

    if (!this.isScheduleDeliveryUpdate || (this.isScheduleDeliveryUpdate && (this.modelOrder.quote_site_contact?.[0]?.id && this.modelOrder.quote_site_contact[0].id !== this.modelOrder.defaultQuoteSiteContactId))) {
      siteContactId = this.modelOrder.quote_site_contact?.[0]?.id;
    }
    // this.debugLogger.log('this.isScheduleDeliveryUpdate:::: ', this.isScheduleDeliveryUpdate)
    // this.debugLogger.log('this.modelOrder:::: ', this.modelOrder)
    const request = this.modelOrder.is_draft === Constants.IS_DRAFT_YES ? this.orderService.saveAsDraftQuoteOrder(this.siteContactForm.value) : this.quoteService.saveOrUpdateQuoteSiteContact(this.siteContactForm.value, siteContactId);
    request.subscribe({
      next: async (data: any) => {
        if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT && !this.isScheduleDeliveryUpdate && !this.isOfflineOrder) {
          await this.syncOrderDetailWithUnleashed();
        }
        this.alertService.success(Constants.SITE_CONTACT_DELIVERY_DETAIL_UPDATE);
        this.modelOrder.quote_site_contact[0].id = data.id;
        this.modelOrder.quote_site_contact[0].name = data.name;
        this.modelOrder.quote_site_contact[0].email = data.email;
        this.modelOrder.quote_site_contact[0].number = data.number;
        this.activeModel.close(true);
      },
      error: () => {
        this.isLoading = false;
      },
      complete: () => this.isLoading = false
    });
  }

  syncOrderDetailWithUnleashed() {
    if (this.modelOrder.id > 0) {
      return new Promise((resolve, reject) => {
        this.quoteService.syncOrderWithUnleashed(null, this.modelOrder.id).subscribe(() => {
          resolve(true);
        }, () => {
          this.isLoading = false;
          reject(false);
        });
      });
    }
  }
}
